export default __webpack_public_path__ + "static/media/mapVillare.1062112d.png";